/* The filing's line of steps. Paper with a hairline; tokens only (ADR-0007). */

.journey {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr);
  gap: 16px 28px;
  align-items: start;
  padding: 16px 18px;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  background: var(--panel);
  min-width: 0;
}

.side {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
}

.due {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  margin: 0;
  color: var(--ink);
  font-size: var(--t-body);
  font-weight: 650;
}

.next {
  margin: 0;
  color: var(--ink-2);
  font-size: var(--t-dense);
}

.now {
  color: var(--muted);
}

.go {
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 650;
  cursor: pointer;
}

.go:hover {
  background: var(--panel-2);
}

.go:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.fine {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-min);
}

@media (width <= 900px) {
  .journey {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (width <= 560px) {
  .go {
    min-height: var(--target-touch);
  }
}
